
import React, { useState, useEffect } from 'react'
import image1 from './facilitiesphotos/computerlab.jpeg'
import image2 from './facilitiesphotos/pharmacognosylab.jpeg'
import image3 from './facilitiesphotos/pharmacologylab.jpeg'
import image4 from './facilitiesphotos/classroom.jpeg'
import image5 from './facilitiesphotos/humanlab.jpeg'
import image6 from './facilitiesphotos/machine.jpeg'
import { AiOutlineClose } from 'react-icons/ai'
import { Link } from 'react-router-dom'
import images1 from './facilitiesphotos/campus1.jpeg'
import images2 from './facilitiesphotos/campus2.jpeg'
import images3 from './facilitiesphotos/campus3.jpeg'
import landscape from './facilitiesphotos/landscape.jpg'
import { Helmet } from "react-helmet";


const Gallary = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])



    let Infrastructure = [

        {
            id: 1,
            imgSrc: images1,
        },
        {
            id: 2,
            imgSrc: images2,
        },

        {
            id: 3,
            imgSrc: images3,
        },





    ]


    let facilities = [


        {
            id: 2,
            imgSrc: image1,
            info: "Computer Lab"
        },

        {
            id: 3,
            imgSrc: image2,
            info: "Pharmacognosy lab"
        },

        {
            id: 4,
            imgSrc: image3,
            info: "Pharmacology Lab"
        },

        {
            id: 5,
            imgSrc: image4,
            info: "Class Room"
        },


        {
            id: 6,
            imgSrc: image5,
            info: "Human Anatomy and Physiology Lab"
        },

        {
            id: 7,
            imgSrc: image6,
            info: "Machine Lab"
        },





    ];


    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');

    const getImg = (imgSrc) => {
        setTempImgSrc(imgSrc);
        setModel(true);
    }



    return (
        <>
          <Helmet>
        <title>Gallery Page</title>
        <meta name="description" content="Information about admission in shinde institute of pharmacy and research , Required Documents" />
      </Helmet>

            <div style={{ marginTop: "6rem" }}>
                <img src={landscape} alt="error" className="landscape" style={{ width: "100%" }}></img>
                <center>  <h1 className="centered">Home {'>'} Gallery</h1>  </center>
            </div>


            <div className={model ? 'model open ' : "model "} >
                <img src={tempimgSrc} className="img-fluid " alt='error' style={{ height: "100%" }} />


                <AiOutlineClose onClick={() => setModel(false)} />
            </div>
            <br />
            <br />
            <br />
            <div className='container mb-5 mt-2' style={{ marginTop: "0rem" }}>
                <div className='row '>
                    <h1 className='' style={{ color: "rgb(44, 110, 17)" }}><span style={{ color: "rgb(151 201 29)" }}> Welcome to shinde </span>  institute of pharmacy and research</h1>
                    <p>
                        Girnai shikshan sanstha was established in 1989.A total of four schools of girnai shikshan sanstha are located in pachora.it is reputed for the quality of its faculty and outstanding platform to the student for undergraduate and postgraduate program. Now girnai shikshan sanstha is starting shinde institute of pharmacy and research from this year.
                    </p>

                </div>

            </div>



            <div className='container '>

                <div className='row '>
                    <h1 style={{ color: "rgb(44, 110, 17)" }}>Facilities</h1>
                    {facilities.map((item, index) => {
                        return (
                            <div className='col-md-4 mt-5' key={index} onClick={() => getImg(item.imgSrc)} >
                                <img src={item.imgSrc} style={{ cursor: "pointer", height: "100%" }} className="img-fluid rounded " alt="error" />
                                <center> <h5 style={{ color: "rgb(44, 110, 17)" }}>{item.info}</h5>  </center>
                            </div>

                        )
                    })}

                </div>

                <div className='row mt-5'>
                    <h1 style={{ color: "rgb(44, 110, 17)" }}>Infrastructure</h1>
                    {Infrastructure.map((item, index) => {
                        return (
                            <div className='col-md-4 mt-4' key={index} onClick={() => getImg(item.imgSrc)} >
                                <img src={item.imgSrc} style={{ cursor: "pointer", height: "100%" }} className="img-fluid rounded " alt="error" />
                            </div>

                        )
                    })}

                </div>
            </div>

            <br></br>
            <br></br>

            <div className='row head2 footer-booknow margin-bottom' style={{ background: "rgb(77 135 25)", marginBottom: "-2.9rem" }} >

                <div className='col-lg-8 col-md-8 ' style={{ color: "white", marginTop: "1.2rem", marginBottom: "1.2rem" }} >
                    <center> <h3 className='small2'>Are you looking for Pharmacy <br></br> College ?</h3></center>

                </div>
                <div className='col-lg-4 col-md-4' style={{ color: "white", marginTop: "2.5rem" }}>
                    <center>  <h4 className='small3 '><i className="fa fa-phone-square" ></i> Call +91 83800 48830 or  <span>    <Link to="/" type="button" className="btn btn-outline-warning mx-1" >
                        Know more
                    </Link></span></h4></center>


                </div>
            </div>


        </>
    )
}

export default Gallary